import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { normalizePathname, resolveRedirect } from "@/lib/redirects";
import { NotFoundHead, NotFoundView } from "@/components/NotFoundView";

/**
 * 404 com fallback de redirect: qualquer URL antiga no formato /slug-do-post
 * que corresponda a um artigo existente é redirecionada para /artigo/slug.
 */
const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const path = normalizePathname(location.pathname);
    const segments = path.split("/").filter(Boolean);

    async function tryResolve() {
      // Só tentamos para caminhos de 1 segmento (padrão legado do blog .com).
      if (segments.length !== 1) {
        if (!cancelled) setChecking(false);
        return;
      }
      const slug = segments[0];
      const { data } = await (supabase as any)
        .from("articles")
        .select("slug")
        .eq("slug", slug)
        .maybeSingle();
      if (cancelled) return;
      if (data?.slug) {
        const target = `/artigo/${data.slug}`;
        const finalTarget = resolveRedirect(target) ?? target;
        navigate(`${finalTarget}${location.search}${location.hash}`, { replace: true });
        return;
      }
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
      setChecking(false);
    }

    setChecking(true);
    tryResolve();
    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search, location.hash, navigate]);

  if (checking) return (<div className="min-h-screen" aria-hidden="true"><NotFoundHead /></div>);

  return <NotFoundView />;
};

export default NotFound;
